import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { getMobileOS } from "../../utils/detect-mobile";
import { InputButton } from "./components/InputButton";
import { filterInputProps, toggleButtonTitle, toggleClickFunc, typePreparation } from "./utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var emptyCallback = function emptyCallback() {
  return undefined;
};
var isAndroid = getMobileOS() === 'android';
var filteredProps = ['className', 'action', 'status', 'passwordVisible', 'maskRegexp', 'mask', 'focus', 'onClear', 'getRef', 'clearable', 'prefix', 'keepInitialValue', 'filterInput', 'forceTouch'];
var TextInput = /*#__PURE__*/function (_Component) {
  _inherits(TextInput, _Component);
  var _super = _createSuper(TextInput);
  function TextInput(props) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "setFocus", function () {
      _this.inputElement.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "getCursorPosition", function () {
      var iCaretPos = 0;
      if (document.selection) {
        _this.inputElement.focus();
        var oSel = document.selection.createRange();
        oSel.moveStart('character', -_this.inputElement.value.length);
        iCaretPos = oSel.text.length;
      } else if (_this.inputElement.selectionStart || _this.inputElement.selectionStart === '0') {
        iCaretPos = _this.inputElement.selectionStart;
      }
      return iCaretPos;
    });
    _defineProperty(_assertThisInitialized(_this), "setCursorPosition", function (caretPos) {
      if (typeof caretPos === 'undefined') return;
      if (_this.inputElement.createTextRange) {
        var range = _this.inputElement.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else if (_this.inputElement.setSelectionRange) {
        if (isAndroid) {
          setTimeout(function () {
            _this.inputElement.setSelectionRange(caretPos, caretPos);
          }, 5);
        } else {
          _this.inputElement.setSelectionRange(caretPos, caretPos);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMask", function (value) {
      var initialValue = _this.state.initialValue;
      var _this$props = _this.props,
        maskRegexp = _this$props.maskRegexp,
        keepInitialValue = _this$props.keepInitialValue,
        prefix = _this$props.prefix;
      var mask = _this.props.mask;
      var maskSpecialCharLength = mask.replace(/[^_]/g, '').length;
      var filteredValue = value.replace(maskRegexp, '').split('');
      var reverceValue = filteredValue.reverse().slice(0, maskSpecialCharLength);
      var resultValue = reverceValue.reverse();
      var lastChar;
      resultValue.forEach(function (char) {
        if (mask.indexOf('_') >= 0) {
          mask = mask.replace('_', char);
          lastChar = char;
        }
      });
      var newValue = mask.slice(0, mask.lastIndexOf(lastChar) + 1);
      var caretPos = newValue.length;
      if (_this.getCursorPosition() !== value.length) {
        caretPos = _this.getCursorPosition();
      }
      if (keepInitialValue && newValue.length < initialValue.length) {
        return [initialValue, initialValue.length];
      }
      if (prefix && newValue.indexOf(prefix) !== 0) {
        var valueWithPrefix = "".concat(prefix).concat(newValue);
        return [valueWithPrefix, valueWithPrefix.length];
      }
      return [newValue, caretPos];
    });
    _defineProperty(_assertThisInitialized(_this), "handleFilter", function (value) {
      var _this$props2 = _this.props,
        filterInput = _this$props2.filterInput,
        mask = _this$props2.mask;
      var valueToReturn = value;
      if (filterInput) valueToReturn = filterInput(valueToReturn);
      if (mask) return _this.handleMask(valueToReturn);
      return [valueToReturn, undefined];
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var inputValue = event.target.value;
      var _this$props3 = _this.props,
        onChange = _this$props3.onChange,
        mask = _this$props3.mask;
      if (mask && mask.length === inputValue.length - 1) {
        return;
      }
      var _this$handleFilter = _this.handleFilter(inputValue),
        _this$handleFilter2 = _slicedToArray(_this$handleFilter, 2),
        value = _this$handleFilter2[0],
        caretPos = _this$handleFilter2[1];
      _this.setState({
        value: value
      }, function () {
        _this.setCursorPosition(caretPos);
      });
      if (onChange) onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      if (_this.props.onBlur) _this.props.onBlur(_this.state.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var _this$props4 = _this.props,
        onFocus = _this$props4.onFocus,
        mask = _this$props4.mask;
      if (onFocus) onFocus(_this.state.value);
      if (mask) {
        setTimeout(function () {
          _this.setCursorPosition(_this.inputElement.value.length);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handlePaste", function (e) {
      if (_this.props.onPaste) {
        _this.props.onPaste(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleHidePassword", function () {
      _this.setState({
        hidePassword: !_this.state.hidePassword
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      var onClear = _this.props.onClear;
      _this.setState({
        value: ''
      });
      if (typeof onClear === 'function') {
        onClear();
      }
    });
    _this.state = {
      initialValue: props.value || null,
      value: props.value || '',
      hidePassword: props.type === 'password' && !props.passwordVisible || false
    };
    return _this;
  }
  _createClass(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getRef = this.props.getRef;
      if (getRef) {
        getRef(this.inputElement);
      }
      if (this.props.focus) this.setFocus();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.value || nextProps.value === '') && this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _cx;
      var _this$props5 = this.props,
        type = _this$props5.type,
        action = _this$props5.action,
        captcha = _this$props5.captcha,
        size = _this$props5.size,
        clearable = _this$props5.clearable,
        demoState = _this$props5.demoState,
        mask = _this$props5.mask,
        onButtonInputClick = _this$props5.onButtonInputClick;
      var _this$state = this.state,
        value = _this$state.value,
        hidePassword = _this$state.hidePassword;

      // eslint-disable-next-line max-len
      var needButton = type === 'password' || type === 'search' && !value || value && (type === 'search' || clearable);
      var buttonClick = function buttonClick() {
        onButtonInputClick === null || onButtonInputClick === void 0 ? void 0 : onButtonInputClick();
        toggleClickFunc(type, value, clearable, _this2.toggleHidePassword, _this2.clear, emptyCallback());
      };
      var buttonTitle = toggleButtonTitle(type, value, clearable, hidePassword);
      var newType = typePreparation(type, hidePassword, mask);
      var captchaImage = captcha ? /*#__PURE__*/React.createElement("img", {
        alt: " ",
        className: cx('captcha'),
        role: "presentation",
        src: captcha,
        "data-t-id": "components-TextInput"
      }) : null;
      var className = cx((_cx = {
        input: true
      }, _defineProperty(_cx, this.props.status, this.props.status), _defineProperty(_cx, "withIcon", type === 'password' || type === 'search' || clearable), _defineProperty(_cx, "withCaptcha", captcha), _defineProperty(_cx, "".concat(size, "Size"), true), _defineProperty(_cx, "".concat(demoState, "State"), typeof demoState === 'string'), _cx));
      return /*#__PURE__*/React.createElement("div", {
        action: action,
        className: cx('wrapper', this.props.className),
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }, captchaImage, /*#__PURE__*/React.createElement("input", _extends({}, filterInputProps(this.handleChange, newType, filteredProps, this.props), {
        className: className,
        onPaste: this.handlePaste,
        ref: function ref(e) {
          _this2.inputElement = e;
        },
        value: value ? value : '' // eslint-disable-line
      })), needButton && /*#__PURE__*/React.createElement(InputButton, _extends({}, this.props, {
        hidePassword: hidePassword,
        onClick: buttonClick,
        title: buttonTitle,
        value: value
      })));
    }
  }]);
  return TextInput;
}(Component);
_defineProperty(TextInput, "defaultProps", {
  type: 'text',
  size: 'default',
  status: '',
  passwordVisible: false,
  maskRegexp: /\+7|\D/g,
  autoComplete: 'on',
  readOnly: false
});
export { TextInput as default };
TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.any,
  type: PropTypes.string,
  action: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoComplete: PropTypes.string,
  clearable: PropTypes.bool,
  passwordVisible: PropTypes.bool,
  captcha: PropTypes.string,
  size: PropTypes.oneOf(['default', 'big']),
  demoState: PropTypes.oneOf(['focus']),
  onChange: PropTypes.func,
  filterInput: PropTypes.func,
  focus: PropTypes.bool,
  mask: PropTypes.string,
  prefix: PropTypes.string,
  maskRegexp: PropTypes.object,
  keepInitialValue: PropTypes.bool,
  forceTouch: PropTypes.bool,
  status: PropTypes.string,
  onClear: PropTypes.func,
  getRef: PropTypes.func,
  onPaste: PropTypes.func,
  onButtonInputClick: PropTypes.func
} : {};